// src/utils/formatters.js

/**
 * Para birimi formatlama fonksiyonu - NULL SAFE
 * @param {number|null|undefined} value - Formatlanacak tutar
 * @returns {string} TL formatında tutar
 */
export const formatCurrency = (value) => {
  // null, undefined, NaN kontrolü
  if (value === null || value === undefined || isNaN(value)) {
    return '0,00 ₺';
  }
  return Number(value).toLocaleString('tr-TR', {
    style: 'currency',
    currency: 'TRY'
  });
};

/**
 * Firestore Timestamp'i tarih string'ine çevirir - NULL SAFE
 * @param {firebase.firestore.Timestamp|Date|string|null|undefined} timestamp - Firebase Timestamp, Date, veya string
 * @param {object} options - toLocaleString options
 * @returns {string} Formatlanmış tarih
 */
export const formatDate = (timestamp, options = { dateStyle: 'short' }) => {
  if (!timestamp) return '-';
  
  try {
    // Firestore Timestamp
    if (timestamp.toDate && typeof timestamp.toDate === 'function') {
      return timestamp.toDate().toLocaleString('tr-TR', options);
    }
    // JavaScript Date
    if (timestamp instanceof Date) {
      return timestamp.toLocaleString('tr-TR', options);
    }
    // String
    if (typeof timestamp === 'string') {
      const date = new Date(timestamp);
      if (!isNaN(date.getTime())) {
        return date.toLocaleString('tr-TR', options);
      }
    }
  } catch (error) {
    console.warn('formatDate hatası:', error);
  }
  
  return '-';
};

/**
 * Firestore Timestamp'i sadece tarih olarak formatlar - NULL SAFE
 * @param {firebase.firestore.Timestamp|Date|string|null|undefined} timestamp - Firebase Timestamp
 * @returns {string} Formatlanmış tarih (örn: 20.11.2025)
 */
export const formatDateOnly = (timestamp) => {
  if (!timestamp) return '-';
  
  try {
    if (timestamp.toDate && typeof timestamp.toDate === 'function') {
      return timestamp.toDate().toLocaleDateString('tr-TR');
    }
    if (timestamp instanceof Date) {
      return timestamp.toLocaleDateString('tr-TR');
    }
    if (typeof timestamp === 'string') {
      const date = new Date(timestamp);
      if (!isNaN(date.getTime())) {
        return date.toLocaleDateString('tr-TR');
      }
    }
  } catch (error) {
    console.warn('formatDateOnly hatası:', error);
  }
  
  return '-';
};

/**
 * Firestore Timestamp'i tarih ve saat olarak formatlar - NULL SAFE
 * @param {firebase.firestore.Timestamp|Date|string|null|undefined} timestamp - Firebase Timestamp
 * @returns {string} Formatlanmış tarih ve saat
 */
export const formatDateTime = (timestamp) => {
  if (!timestamp) return '-';
  
  try {
    if (timestamp.toDate && typeof timestamp.toDate === 'function') {
      return timestamp.toDate().toLocaleString('tr-TR', {
        dateStyle: 'short',
        timeStyle: 'short'
      });
    }
    if (timestamp instanceof Date) {
      return timestamp.toLocaleString('tr-TR', {
        dateStyle: 'short',
        timeStyle: 'short'
      });
    }
    if (typeof timestamp === 'string') {
      const date = new Date(timestamp);
      if (!isNaN(date.getTime())) {
        return date.toLocaleString('tr-TR', {
          dateStyle: 'short',
          timeStyle: 'short'
        });
      }
    }
  } catch (error) {
    console.warn('formatDateTime hatası:', error);
  }
  
  return '-';
};

/**
 * Telefon numarasını formatlar
 * @param {string} phone - Telefon numarası
 * @returns {string} Formatlanmış telefon
 */
export const formatPhone = (phone) => {
  if (!phone) return '-';
  // 05551234567 -> 0555 123 45 67
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length === 11) {
    return `${cleaned.slice(0, 4)} ${cleaned.slice(4, 7)} ${cleaned.slice(7, 9)} ${cleaned.slice(9)}`;
  }
  return phone;
};
